Number.prototype.toScale = function toScale(scale, inFunc) {
    if (scale || scale == 0) {
        let func = inFunc || 'round';
        let inv = Math.pow(10, scale);
        return Math[func](this * inv) / inv;
    }

    // return original number if there is no scale
    return this;
};
